.quiz { display: grid; grid-template-columns: 1fr 420px; min-height: 600px; background: var(--paper); }
.quiz > * { min-width: 0; }
.main { padding: 40px 48px; min-width: 0; }

.pips { display: flex; gap: 5px; margin-top: 16px; flex-wrap: wrap; }
.pip {
  width: 34px; height: 4px; border-radius: 2px; border: none; padding: 0;
  background: var(--ink-12); cursor: pointer;
  transition: background-color .2s ease;
}
.pip.right { background: var(--accent); }
.pip.wrong { background: var(--orange); }
.pip.here  { background: var(--olive); }
.pip.done  { background: var(--ink-68); }   /* an ungraded question, answered — no right or wrong */

.prompt { margin: 26px 0 0; max-width: 26ch; font: 300 34px/1.16 var(--serif); color: var(--ink); text-wrap: pretty; }

.answers { display: flex; flex-direction: column; gap: 10px; margin-top: 24px; max-width: 620px; }
.answer {
  display: flex; align-items: center; gap: 14px; padding: 16px 18px;
  border-radius: var(--radius-lg); border: 1px solid var(--ink-16);
  background: var(--card); color: var(--ink); text-align: left; cursor: pointer;
  font: 400 14.5px/1.5 var(--sans);
  transition: border-color .15s ease, background-color .15s ease;
}
.answer:hover:not(:disabled) { border-color: var(--olive); }
.answer:disabled { cursor: default; }
.answer.right { background: var(--check-bg); border-color: var(--accent); }
.answer.wrong { background: var(--wrong-bg); border-color: var(--orange); }
.answer.picked { border-color: var(--olive); }
.answer.picked .key { background: var(--olive); color: var(--paper); }
.answerText { flex: 1; }
.answerTag { font: 400 11px var(--mono); opacity: .7; }

.key {
  display: flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; flex: none; border-radius: var(--radius-sm);
  font: 600 12px var(--mono); background: var(--ink-08); color: var(--ink);
}
.answer.right .key { background: var(--accent); color: #121212; }
.answer.wrong .key { background: var(--orange); color: #f4f4f2; }

.why {
  margin-top: 0; max-height: 0; overflow: hidden; padding: 0 20px;
  border-left: 3px solid transparent; background: transparent;
  transition: max-height .28s ease, padding .28s ease, margin .28s ease, background-color .28s ease;
}
.why.open { margin-top: 24px; max-height: 340px; padding: 18px 20px; border-left-color: var(--olive); background: var(--panel); }
.why p { margin: 8px 0 0; font: 400 14px/1.65 var(--sans); color: var(--body); }

.nav { display: flex; gap: 10px; margin-top: 26px; }

/* Result panel ----------------------------------------------------------- */
.aside {
  padding: 40px; background: var(--panel); border-left: 1px solid var(--ink-12);
  display: flex; flex-direction: column;
}
.result { margin-top: 22px; display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
.ring {
  position: relative; width: 124px; height: 124px; flex: none; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
}
.ringInner {
  width: 96px; height: 96px; border-radius: 50%; background: var(--panel);
  display: flex; flex-direction: column; align-items: center; justify-content: center;
}
.ringScore { font: 300 30px/1 var(--serif); color: var(--ink); }
.ringLabel { font: 400 9.5px var(--mono); letter-spacing: .14em; color: var(--ink-55); margin-top: 4px; }

.resultText { flex: 1; min-width: 160px; }
.resultTitle { font: 300 22px/1.2 var(--serif); color: var(--ink); }
.resultBody { margin: 8px 0 0; font: 400 13px/1.6 var(--sans); color: var(--ink-68); }

.skills { margin-top: 28px; border-top: 1px solid var(--rule); }
.skill { padding: 13px 0; border-bottom: 1px solid var(--ink-12); }
.skillHead { display: flex; justify-content: space-between; font: 500 12.5px var(--sans); color: var(--ink); }
.skillScore { font: 400 11px var(--mono); color: var(--ink-55); }
.skillBar { margin-top: 7px; height: 4px; border-radius: 2px; background: var(--ink-12); overflow: hidden; }
.skillBar > span { display: block; height: 100%; background: var(--accent); transition: width .3s ease; }
.skillBar > span.low { background: var(--orange); }

.unlocked {
  margin-top: 26px; padding: 16px; background: var(--paper);
  border-radius: var(--radius-lg); border: 1px solid var(--ink-12);
}
.unlockedName { margin-top: 8px; font: 400 15px var(--serif); color: var(--ink); }

.asideActions { display: flex; gap: 10px; margin-top: auto; padding-top: 26px; }
.asideActions > * { flex: 1; }

@media (max-width: 940px) {
  .quiz { grid-template-columns: 1fr; }
  .main { padding: 30px 22px; }
  .aside { padding: 30px 22px; border-left: none; border-top: 1px solid var(--ink-12); }
  .prompt { font-size: 28px; }
}

/* the quiz's own framing, e.g. "this is ungraded, and why" */
.intro { margin: 14px 0 0; font: 400 14px/1.65 var(--sans); color: var(--ink-68); max-width: 60ch; }

/* "I don't know" (D-040): offered, never louder than an answer. */
.idk {
  align-self: flex-start; border: none; background: none; padding: 6px 2px; cursor: pointer;
  font: 500 13px var(--sans); color: var(--ink-55); text-decoration: underline;
}
.idk:hover { color: var(--ink); }
.idkNote { margin: 4px 0 0; font: 400 13px var(--sans); color: var(--ink-55); }
